import React, { useState, useEffect } from 'react';
import { todoApi } from '../services/api';

const TodoList = () => {
  const [todos, setTodos] = useState([]);
  const [newTodo, setNewTodo] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 获取所有待办事项
  useEffect(() => {
    fetchTodos();
  }, []);

  const fetchTodos = async () => {
    try {
      setLoading(true);
      const data = await todoApi.getAllTodos();
      setTodos(data);
    } catch (err) {
      setError('获取待办事项失败');
      // 如果API失败，使用本地数据
      setTodos([
        { id: 1, text: '学习React', completed: false },
        { id: 2, text: '部署到Cloudflare', completed: false },
        { id: 3, text: '学习前端开发', completed: true },
      ]);
    } finally {
      setLoading(false);
    }
  };

  // 添加新的todo
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newTodo.trim()) return;

    try {
      const newTodoItem = await todoApi.createTodo(newTodo);
      setTodos([...todos, newTodoItem]);
      setNewTodo('');
    } catch (err) {
      setError('添加待办事项失败');
      // 失败时使用本地添加
      const localNewTodo = {
        id: Date.now(),
        text: newTodo,
        completed: false
      };
      setTodos([...todos, localNewTodo]);
      setNewTodo('');
    }
  };

  // 切换完成状态
  const toggleTodo = async (id) => {
    try {
      const todoToUpdate = todos.find(todo => todo.id === id);
      const updatedTodo = await todoApi.updateTodo(id, {
        completed: !todoToUpdate.completed
      });
      setTodos(todos.map(todo =>
        todo.id === id ? updatedTodo : todo
      ));
    } catch (err) {
      setError('更新待办事项失败');
      // 失败时使用本地更新
      setTodos(todos.map(todo =>
        todo.id === id ? { ...todo, completed: !todo.completed } : todo
      ));
    }
  };

  // 删除todo
  const deleteTodo = async (id) => {
    try {
      await todoApi.deleteTodo(id);
      setTodos(todos.filter(todo => todo.id !== id));
    } catch (err) {
      setError('删除待办事项失败');
      // 失败时使用本地删除
      setTodos(todos.filter(todo => todo.id !== id));
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>加载中...</div>;
  }

  return (
    <div className="todo-container" style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
      {error && (
        <div style={{ 
          padding: '10px', 
          backgroundColor: '#ffebee', 
          color: '#c62828', 
          marginBottom: '10px',
          borderRadius: '4px'
        }}>
          {error}
        </div>
      )}
      
      <h1 style={{ textAlign: 'center', color: '#333' }}>待办事项列表</h1>
      
      <form onSubmit={handleSubmit} style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
        <input
          type="text"
          value={newTodo}
          onChange={(e) => setNewTodo(e.target.value)}
          placeholder="添加新的待办事项"
          style={{
            flex: 1,
            padding: '8px',
            borderRadius: '4px',
            border: '1px solid #ddd'
          }}
        />
        <button 
          type="submit"
          style={{
            padding: '8px 16px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          添加
        </button>
      </form>

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {todos.map(todo => (
          <li 
            key={todo.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px',
              marginBottom: '8px',
              backgroundColor: '#f9f9f9',
              borderRadius: '4px',
              gap: '10px'
            }}
          >
            <input
              type="checkbox"
              checked={todo.completed}
              onChange={() => toggleTodo(todo.id)}
            />
            <span style={{
              flex: 1,
              textDecoration: todo.completed ? 'line-through' : 'none',
              color: todo.completed ? '#888' : '#333'
            }}>
              {todo.text}
            </span>
            <button
              onClick={() => deleteTodo(todo.id)}
              style={{
                padding: '4px 8px',
                backgroundColor: '#ff4444',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              删除
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TodoList; 